
 <template >
  <div class="company-search">
    <site-header :userAuthenticated="true"></site-header>
    <breadcrumb>
      <router-link to="/">Home</router-link>
      <span> > </span>
      <router-link v-if="!companySearchId" to="/search" class="active"
        >Company Search</router-link
      >
      <router-link
        v-if="companySearchId"
        :to="'/search/' + companySearchId"
        class="active"
        >Company Search</router-link
      >
      <print-icon></print-icon>
    </breadcrumb>

    <div class="container">
      <main-content>
        <h1 class="visuallyhidden">Company Search</h1>
        <form @submit.prevent="displayResults()">
            <div class="top-bar">

                <div class="display-results-form">

                    <company-count :search="search"></company-count>
                    <input-button class="search-btn"
                                  :btn-class="'btn-primary'"
                                  :disabled="saving || hasErrors || highResultsCount|| wildCardError || search.loadingResults">
                        Display results<font-awesome-icon icon="search" />
                    </input-button>
                    <font-awesome-icon icon="spinner"
                                       v-if="saving || search.recalculatingCount || loading || search.loadingResults" />

                    <h2 class="error" v-if="wildCardError == true">Wildcard Keywords Must Be Split Up </h2>

                    <h3 class="information" v-if="search.loadingResults == true"><font-awesome-icon style="	display:inline-block;!important" icon="spinner"></font-awesome-icon>Results are being prepared... </h3>


                </div>

                <div class="tools-btns">
                    <load-saved-search @contentRead="loadSavedSearch"
                                       @error="loadSavedSearchError"
                                       class="load-search">
                        Load Search <font-awesome-icon icon="upload" />
                    </load-saved-search>
                    <save-search class="save-search" :search="search">
                        Save Search <font-awesome-icon icon="save" />
                    </save-search>
                    <div @click.prevent="clearAllValues">
                        <input-button :btn-class="'btn-grey'">
                            Clear All <font-awesome-icon icon="minus-circle" />
                        </input-button>
                    </div>
                </div>
            </div>

            <section class="form-section company-search-section">

                <h2>
                    Company Search
                    <button aria-label="Minimise company search"
                            @click.prevent="toggleSection('companySearch')">
                        <font-awesome-icon :icon="sectionIcon('companySearch')" />
                    </button>
                    <button aria-label="Clear company search values"
                            @click.prevent="clearValuesFromSection('companySearch')">
                        <font-awesome-icon icon="times-circle" />
                    </button>
                </h2>

                <div v-if="sectionsVisible.companySearch">
                    <div class="fields-wrapper group">
                        <text-input class="field"
                                    :label="'Company name'"
                                    :identifier="'companyName'"
                                    :display="'row'"
                                    :label-width="250"
                                    :attrs="{ placeholder: 'Company name' }"
                                    v-model="search.companyName"
                                    v-on:valueChanged="formChanged"></text-input>
                        <text-input class="field"
                                    :label="'Website'"
                                    :identifier="'website'"
                                    :display="'row'"
                                    :label-width="250"
                                    :attrs="{ placeholder: 'Website' }"
                                    v-model="search.website"
                                    v-on:valueChanged="formChanged"></text-input>
                    </div>

                    <div class="fields-wrapper group">
                        <text-input class="field"
                                    :label="'Company number'"
                                    :identifier="'companyNumber'"
                                    :display="'row'"
                                    :label-width="250"
                                    :attrs="{ placeholder: 'Company number' }"
                                    v-model="search.companyNumber"
                                    :error="searchError.CompanyNumber"
                                    v-on:valueChanged="formChanged"></text-input>
                        <multi-select-input class="field"
                                            :label="'Post code(s)'"
                                            :identifier="'postCodes'"
                                            :display="'row'"
                                            :label-width="250"
                                            :attrs="{ placeholder: 'Post code(s)' }"
                                            :options="postcodes"
                                            :option-label="'area'"
                                            :option-track-by="'postcodeAreaId'"
                                            v-model="search.postcodes"
                                            v-on:valueChanged="formChanged"
                                            :multiple="true"></multi-select-input>
                    </div>

                    <div class="fields-wrapper group">
                        <multi-select-input class="field"
                                            :label="'Region(s)'"
                                            :identifier="'regions'"
                                            :display="'row'"
                                            :label-width="250"
                                            :attrs="{ placeholder: 'Region(s)' }"
                                            :options="regions"
                                            :option-label="'name'"
                                            :option-track-by="'regionId'"
                                            v-model="search.regions"
                                            v-on:valueChanged="formChanged"
                                            :multiple="true"></multi-select-input>
                        <multi-select-input class="field"
                                            :label="'Country(s)'"
                                            :identifier="'countries'"
                                            :display="'row'"
                                            :label-width="250"
                                            :attrs="{ placeholder: 'Country(s)' }"
                                            :options="countries"
                                            :option-label="'name'"
                                            :option-track-by="'companySearchCountryId'"
                                            v-model="search.countries"
                                            v-on:valueChanged="formChanged"
                                            :multiple="true"></multi-select-input>
                    </div>

                    <div class="fields-wrapper group">
                        <checkbox-input class="field"
                                        :label="'Non Limited Only'"
                                        :identifier="'nonLimitedOnly'"
                                        v-model="search.nonLimitedOnly"
                                        v-on:valueChanged="nonLimitedOnlyChanged"></checkbox-input>
                    </div>
                    <div class="fields-wrapper group">
                        <checkbox-input class="field"
                                        :label="'Exclude Blocked'"
                                        :identifier="'excludeBlocked'"
                                        v-model="search.excludeBlocked"
                                        v-on:valueChanged="excludeBlockedChanged"></checkbox-input>
                    </div>
                </div>
            </section>

            <section class="form-section industry-activities">
                <h2>
                    Industry &amp; Activities
                    <button aria-label="Minimise company search"
                            @click.prevent="toggleSection('industry')">
                        <font-awesome-icon :icon="sectionIcon('industry')" />
                    </button>
                    <button aria-label="Clear company search values"
                            @click.prevent="clearValuesFromSection('industry')">
                        <font-awesome-icon icon="times-circle" />
                    </button>
                </h2>

                <div v-if="sectionsVisible.industry">
                    <div class="divider">
                        <table>
                            <tr>
                                <td><p>Keywords to include from Trade Description</p></td>
                                <td class="optional-control">
                                    <checkbox-input class="field"
                                                    :label="'Include all'"
                                                    :identifier="'includeAll'"
                                                    v-model="search.keywordIncludeAll"
                                                    v-on:valueChanged="setKeywordIncludeAll"></checkbox-input>
                                </td>
                                <td class="optional-control">
                                    <checkbox-input class="field"
                                                    :label="'Search all'"
                                                    :identifier="'searchAll'"
                                                    v-model="search.keywordSearchAll"
                                                    v-on:valueChanged="setKeywordSearchAll"></checkbox-input>
                                </td>
                                <td></td>
                            </tr>
                            <tr v-for="(item, index) in search.includedKeywords" :key="item.id">
                                <td>
                                    <text-input class="field text-field"
                                                :identifier="'includeKeyword' + index"
                                                :attrs="{ placeholder: 'Keywords' }"
                                                v-model="item.keyword"
                                                v-on:valueChanged="formChanged"
                                                :error="
                          searchError['IncludedKeywords[' + index + ']Keyword']
                        "></text-input>
                                </td>
                                <td class="optional-control">
                                    <checkbox-input class="field"
                                                    :label="'Must include'"
                                                    :identifier="'mustInclude' + index"
                                                    v-model="item.mustInclude"
                                                    v-on:valueChanged="formChanged"></checkbox-input>
                                </td>
                                <td class="optional-control">
                                    <checkbox-input class="field"
                                                    :label="'Search name'"
                                                    :identifier="'searchName' + index"
                                                    v-model="item.searchName"
                                                    v-on:valueChanged="formChanged"></checkbox-input>
                                </td>
                                <td>
                                    <button type="button"
                                            class="remove-button"
                                            @click.prevent="removeIncludedKeyword(index)">
                                        <font-awesome-icon icon="minus-circle" /> Remove
                                    </button>
                                </td>
                            </tr>
                        </table>
                        <button class="add-button"
                                type="button"
                                v-on:click="addIncludedKeyword">
                            <font-awesome-icon icon="plus-circle" /> Add keyword
                        </button>
                        <div class="extra-controls">
                            <checkbox-input class="field"
                                            :label="'Include keywords'"
                                            :identifier="'includeKeywords'"
                                            v-model="search.includeKeywords"
                                            v-on:valueChanged="formChanged"></checkbox-input>
                            <checkbox-input class="field"
                                            :label="'Include acquisition keywords'"
                                            :identifier="'includeAcquisitionKeywords'"
                                            v-model="search.includeAcquisitionKeywords"
                                            v-on:valueChanged="formChanged"></checkbox-input>
                            <checkbox-input class="field"
                                            :label="'Include Overview'"
                                            :identifier="'includeOverview'"
                                            v-model="search.includeOverview"
                                            v-on:valueChanged="formChanged"></checkbox-input>
                        </div>
                    </div>

                    <div class="divider">
                        <table>
                            <tr>
                                <td><p>Keywords to exclude</p></td>
                            </tr>
                            <tr v-for="(item, index) in search.excludedKeywords" :key="item.id">
                                <td>
                                    <text-input class="field text-field"
                                                :identifier="'excludeKeyword' + index"
                                                :attrs="{ placeholder: 'Keywords' }"
                                                v-model="item.keyword"
                                                v-on:valueChanged="formChanged"
                                                :error="
                          searchError['ExcludedKeywords[' + index + ']Keyword']
                        "></text-input>
                                </td>
                                <td>
                                    <button type="button"
                                            class="remove-button"
                                            @click.prevent="removeExcludedKeyword(index)">
                                        <font-awesome-icon icon="minus-circle" /> Remove
                                    </button>
                                </td>
                            </tr>
                        </table>
                        <button class="add-button"
                                type="button"
                                v-on:click="addExcludedKeyword">
                            <font-awesome-icon icon="plus-circle" /> Add keyword
                        </button>
                    </div>

                    <div class="divider">
                        <table>
                            <tr>
                                <td>
                                    <p>UK SIC (2007) codes</p>
                                    <p class="error" v-if="searchError.SicCodes">
                                        <!-- {{ searchError.SicCodes }} -->
                                    </p>
                                </td>
                                <td colspan="3" v-if="search.sicCodes.length > 0">
                                    <checkbox-input class="field italics"
                                                    :label="'Must include all SIC codes'"
                                                    :identifier="'mustIncludeSicCodes'"
                                                    v-model="search.mustIncludeSicCodes"
                                                    v-on:valueChanged="formChanged"></checkbox-input>
                                </td>
                            </tr>
                            <tr v-for="(item, index) in search.sicCodes" :key="item.id">
                                <td>
                                    <multi-select-input class="field"
                                                        :label="'SIC Code'"
                                                        :identifier="'siccode' + index"
                                                        :display="'row'"
                                                        :label-width="250"
                                                        :attrs="{ placeholder: 'SIC Code' }"
                                                        :options="sicCodes"
                                                        :option-label="'sicCode'"
                                                        :option-track-by="'sicCode'"
                                                        :multiple="false"
                                                        v-on:valueChanged="formChanged"
                                                        v-model="item.sicCodeId"
                                                        :error="searchError['SicCodes[' + index + ']SicCodeId']"></multi-select-input>
                                </td>
                                <td class="optional-control">
                                    <radio-input class="field"
                                                 v-model="item.include"
                                                 :label="'Include'"
                                                 :identifier="'includeSicCode' + index"
                                                 :realValue="true"
                                                 v-on:valueChanged="formChanged"></radio-input>
                                </td>
                                <td class="optional-control">
                                    <radio-input class="field"
                                                 v-model="item.include"
                                                 :label="'Exclude'"
                                                 :identifier="'excludeSicCode' + index"
                                                 :realValue="false"
                                                 v-on:valueChanged="formChanged"></radio-input>
                                </td>
                                <td>
                                    <button class="remove-button"
                                            @click.prevent="removeSicCode(index)"
                                            type="button">
                                        <font-awesome-icon icon="minus-circle" /> Remove
                                    </button>
                                </td>
                            </tr>
                        </table>
                        <button class="add-button"
                                v-on:click="addSicCode"
                                type="button">
                            <font-awesome-icon icon="plus-circle" /> Add code
                        </button>
                    </div>

                    <div class="divider">
                        <table>
                            <tr>
                                <td colspan="2">
                                    <p>Sectors</p>
                                    <p class="error" v-if="searchError.CompanySectors">
                                        <!-- {{ searchError.CompanySectors }} -->
                                    </p>
                                </td>
                                <!--<td colspan="3" v-if="search.sectors.length > 0">
                                                <checkbox-input class="field italics" :label="'Must include all Sectors'" :identifier="'mustIncludeSectors'" v-model="search.mustIncludeSectors" v-on:valueChanged="formChanged"></checkbox-input>
                                            </td-->
                            </tr>
                            <tr v-for="(item, index) in search.sectors" :key="item.id">
                                <td>
                                    <select-input class="field text-field"
                                                  v-model="item.sectorId"
                                                  :identifier="'sector' + index"
                                                  :defaultname="'Sector'"
                                                  :defaultvalue="''"
                                                  :defaultdisabled="true"
                                                  :options="sectors"
                                                  v-on:valueChanged="
                          formChanged();
                          setSectorName(item);
                        "
                                                  :error="searchError['Sector[' + index + ']SectorId']"></select-input>
                                </td>
                                <td>
                                    <select-input class="field text-field"
                                                  v-model="item.subSectorId"
                                                  :identifier="'subSector' + index"
                                                  :defaultname="'All Sub Sectors'"
                                                  :defaultvalue=0
                                                  :defaultdisabled="false"
                                                  :options="filterSubSectors(item.sectorId)"
                                                  v-on:valueChanged="
                          formChanged();
                          setSubSectorName(item);
                        "></select-input>
                                </td>
                                <td class="optional-control">
                                    <radio-input class="field"
                                                 v-model="item.include"
                                                 :label="'Must Include'"
                                                 :identifier="'mustIncludeSector' + index"
                                                 :realValue="2"
                                                 v-on:valueChanged="formChanged"></radio-input>
                                </td>
                                <td class="optional-control">
                                    <radio-input class="field"
                                                 v-model="item.include"
                                                 :label="'Include'"
                                                 :identifier="'includeSector' + index"
                                                 :realValue="1"
                                                 v-on:valueChanged="formChanged"></radio-input>
                                </td>
                                <td class="optional-control">
                                    <radio-input class="field"
                                                 v-model="item.include"
                                                 :label="'Exclude'"
                                                 :identifier="'excludeSector' + index"
                                                 :realValue="0"
                                                 v-on:valueChanged="formChanged"></radio-input>
                                </td>
                                <td>
                                    <button class="remove-button"
                                            v-on:click="removeSector(index)"
                                            type="button">
                                        <font-awesome-icon icon="minus-circle" /> Remove
                                    </button>
                                </td>
                            </tr>
                        </table>
                        <button class="add-button" v-on:click="addSector" type="button">
                            <font-awesome-icon icon="plus-circle" /> Add sector
                        </button>
                    </div>
                </div>
            </section>

            <section class="form-section financials"
                     v-bind:class="{ disabled: search.nonLimitedOnly }">
                <h2>
                    Financials &amp; Employees
                    <button aria-label="Minimise company search"
                            @click.prevent="toggleSection('financials')">
                        <font-awesome-icon :icon="sectionIcon('financials')" />
                    </button>
                    <button aria-label="Clear company search values"
                            @click.prevent="clearValuesFromSection('financials')">
                        <font-awesome-icon icon="times-circle" />
                    </button>
                </h2>
                <div v-if="sectionsVisible.financials">
                    <div class="fields-wrapper group">
                        <p>Turnover</p>
                        <text-input v-model.number="search.minTurnover" type="number"
                                    class="field financials"
                                    :label="'min'"
                                    :attrs="{ step: 0.001, disabled: search.nonLimitedOnly }"
                                    :identifier="'minTurnover'"
                                    :display="'row'"
                                    :label-width="50"
                                    v-on:valueChanged="formChanged"
                                    :error="searchError.MinTurnover"></text-input>
                        <text-input v-model.number="search.maxTurnover" type="number"
                                    class="field financials"
                                    :label="'max'"
                                    :attrs="{ step: 0.001, disabled: search.nonLimitedOnly }"
                                    :identifier="'maxTurnover'"
                                    :display="'row'"
                                    :label-width="50"
                                    v-on:valueChanged="formChanged"
                                    :error="searchError.MaxTurnover"></text-input>
                        <p class="mil">mil GDP</p>
                        <checkbox-input class="field"
                                        :label="'Must include'"
                                        :attrs="{ disabled: search.nonLimitedOnly }"
                                        :identifier="'mustIncludeTurnover'"
                                        v-model="search.mustIncludeTurnover"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                    </div>

                    <div class="fields-wrapper group">
                        <p>EBITDA</p>
                        <text-input class="field financials"
                                    :label="'min'"
                                    :type="'number'"
                                    :attrs="{ step: 0.001, disabled: search.nonLimitedOnly }"
                                    :identifier="'minEBITDA'"
                                    :display="'row'"
                                    :label-width="50"
                                    v-model="search.minEBITDA"
                                    v-on:valueChanged="formChanged"
                                    :error="searchError.MinEBITDA"></text-input>
                        <text-input class="field financials"
                                    :label="'max'"
                                    :type="'number'"
                                    :attrs="{ step: 0.001, disabled: search.nonLimitedOnly }"
                                    :identifier="'maxEBITDA'"
                                    :display="'row'"
                                    :label-width="50"
                                    v-model="search.maxEBITDA"
                                    v-on:valueChanged="formChanged"
                                    :error="searchError.MaxEBITDA"></text-input>
                        <p class="mil">mil GDP</p>
                        <checkbox-input class="field"
                                        :label="'Must include'"
                                        :attrs="{ disabled: search.nonLimitedOnly }"
                                        :identifier="'mustIncludeEBITDA'"
                                        v-model="search.mustIncludeEBITDA"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                    </div>

                    <div class="fields-wrapper group">
                        <p>Shareholders Funds</p>
                        <text-input class="field financials"
                                    :label="'min'"
                                    :type="'number'"
                                    :attrs="{ step: 0.001, disabled: search.nonLimitedOnly }"
                                    :identifier="'minShareholdersFunds'"
                                    :display="'row'"
                                    :label-width="50"
                                    v-model="search.minShareholdersFunds"
                                    v-on:valueChanged="formChanged"
                                    :error="searchError.MinShareholdersFunds"></text-input>
                        <text-input class="field financials"
                                    :label="'max'"
                                    :type="'number'"
                                    :attrs="{ step: 0.001, disabled: search.nonLimitedOnly }"
                                    :identifier="'maxShareholdersFunds'"
                                    :display="'row'"
                                    :label-width="50"
                                    v-model="search.maxShareholdersFunds"
                                    v-on:valueChanged="formChanged"
                                    :error="searchError.MaxShareholdersFunds"></text-input>
                        <p class="mil">mil GDP</p>
                        <checkbox-input class="field"
                                        :label="'Must include'"
                                        :attrs="{ disabled: search.nonLimitedOnly }"
                                        :identifier="'mustIncludeShareholdersFunds'"
                                        v-model="search.mustIncludeShareholdersFunds"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                    </div>

                    <div class="fields-wrapper group">
                        <p>Cash</p>
                        <text-input class="field financials"
                                    :label="'min'"
                                    :type="'number'"
                                    :attrs="{ step: 0.001, disabled: search.nonLimitedOnly }"
                                    :identifier="'minCash'"
                                    :display="'row'"
                                    :label-width="50"
                                    v-model="search.minCash"
                                    v-on:valueChanged="formChanged"
                                    :error="searchError.MinCash"></text-input>
                        <text-input class="field financials"
                                    :label="'max'"
                                    :type="'number'"
                                    :attrs="{ step: 0.001, disabled: search.nonLimitedOnly }"
                                    :identifier="'maxCash'"
                                    :display="'row'"
                                    :label-width="50"
                                    v-model="search.maxCash"
                                    v-on:valueChanged="formChanged"
                                    :error="searchError.MaxCash"></text-input>
                        <p class="mil">mil GDP</p>
                        <checkbox-input class="field"
                                        :label="'Must include'"
                                        :attrs="{ disabled: search.nonLimitedOnly }"
                                        :identifier="'mustIncludeCash'"
                                        v-model="search.mustIncludeCash"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                    </div>

                    <div class="fields-wrapper group">
                        <p>Employees</p>
                        <text-input class="field financials"
                                    :label="'min'"
                                    :type="'number'"
                                    :attrs="{ step: 1, disabled: search.nonLimitedOnly }"
                                    :identifier="'minEmployees'"
                                    :display="'row'"
                                    :label-width="50"
                                    v-model="search.minEmployees"
                                    v-on:valueChanged="formChanged"
                                    :error="searchError.MinEmployees"></text-input>
                        <text-input class="field financials"
                                    :label="'max'"
                                    :type="'number'"
                                    :attrs="{ step: 1, disabled: search.nonLimitedOnly }"
                                    :identifier="'maxEmployees'"
                                    :display="'row'"
                                    :label-width="50"
                                    v-model="search.maxEmployees"
                                    v-on:valueChanged="formChanged"
                                    :error="searchError.MaxEmployees"></text-input>
                        <p class="mil"></p>
                        <checkbox-input class="field"
                                        :label="'Must include'"
                                        :attrs="{ disabled: search.nonLimitedOnly }"
                                        :identifier="'mustIncludeEmployees'"
                                        v-model="search.mustIncludeEmployees"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                    </div>

                    <div class="extra-controls">
                        <checkbox-input class="field"
                                        :label="'Include projections / CVS'"
                                        :identifier="'includeProjectionsCVS'"
                                        v-model="search.includeProjectionsCVS"
                                        v-on:valueChanged="formChanged"
                                        :error="searchError.IncludeProjectionsCVS"></checkbox-input>
                        <!--<checkbox-input class="field" :label="'Include turnover estimates'" :identifier="'includeTurnoverEstimates'" v-model="search.includeTurnoverEstimates" v-on:valueChanged="formChanged" :error="searchError.IncludeTurnoverEstimates"></checkbox-input>-->
                    </div>
                </div>
            </section>

            <section class="form-section buyer-traits">
                <h2>
                    Buyer Traits
                    <button aria-label="Minimise company search"
                            @click.prevent="toggleSection('buyerTraits')">
                        <font-awesome-icon :icon="sectionIcon('buyerTraits')" />
                    </button>
                    <button aria-label="Clear company search values"
                            @click.prevent="clearValuesFromSection('buyerTraits')">
                        <font-awesome-icon icon="times-circle" />
                    </button>
                </h2>

                <div v-if="sectionsVisible.buyerTraits">
                    <div class="fields-grid">
                        <span class="field"></span>
                        <span class="field"></span>
                        <checkbox-input class="field italics"
                                        v-bind:class="{ disabled: search.nonLimitedOnly }"
                                        :label="'Must include all Buyer Traits'"
                                        :identifier="'mustIncludeBuyerTraits'"
                                        :attrs="{ disabled: search.nonLimitedOnly }"
                                        v-model="search.mustIncludeBuyerTraits"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                    </div>

                    <div class="fields-grid">
                        <checkbox-input class="field"
                                        :label="'Increasing cash'"
                                        v-bind:class="{ disabled: search.nonLimitedOnly }"
                                        :identifier="'increasingCash'"
                                        :attrs="{ disabled: search.nonLimitedOnly }"
                                        v-model="search.increasingCash"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                        <checkbox-input class="field"
                                        :label="'Turnover growth'"
                                        v-bind:class="{ disabled: search.nonLimitedOnly }"
                                        :identifier="'turnoverGrowth'"
                                        :attrs="{ disabled: search.nonLimitedOnly }"
                                        v-model="search.turnoverGrowth"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                        <checkbox-input class="field"
                                        :label="'Increasing total assets'"
                                        v-bind:class="{ disabled: search.nonLimitedOnly }"
                                        :identifier="'increasingTotalAssets'"
                                        :attrs="{ disabled: search.nonLimitedOnly }"
                                        v-model="search.increasingTotalAssets"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                    </div>

                    <div class="fields-grid">
                        <checkbox-input class="field"
                                        :label="'Signed NDA only'"
                                        v-bind:class="{ disabled: search.excludeSignedNDA }"
                                        :identifier="'signedNDAOnly'"
                                        :attrs="{ disabled: search.excludeSignedNDA }"
                                        v-model="search.signedNDAOnly"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                        <checkbox-input class="field"
                                        :label="'Exclude Signed NDA'"
                                        v-bind:class="{ disabled: search.signedNDAOnly }"
                                        :identifier="'excludeSignedNDA'"
                                        :attrs="{ disabled: search.signedNDAOnly }"
                                        v-model="search.excludeSignedNDA"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                        <checkbox-input class="field"
                                        :label="'Profit growth'"
                                        v-bind:class="{ disabled: search.nonLimitedOnly }"
                                        :identifier="'profitGrowth'"
                                        :attrs="{ disabled: search.nonLimitedOnly }"
                                        v-model="search.profitGrowth"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                    </div>

                    <div class="fields-grid">
                        <checkbox-input class="field"
                                        :label="'Profit margin growth'"
                                        v-bind:class="{ disabled: search.nonLimitedOnly }"
                                        :identifier="'profitMarginGrowth'"
                                        :attrs="{ disabled: search.nonLimitedOnly }"
                                        v-model="search.profitMarginGrowth"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                        <checkbox-input class="field"
                                        :label="'Employee growth'"
                                        v-bind:class="{ disabled: search.nonLimitedOnly }"
                                        :identifier="'employeeGrowth'"
                                        :attrs="{ disabled: search.nonLimitedOnly }"
                                        v-model="search.employeeGrowth"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                        <checkbox-input class="field"
                                        :label="'Private Equity Owned'"
                                        v-bind:class="{ disabled: search.nonLimitedOnly }"
                                        :identifier="'plcOwned'"
                                        :attrs="{ disabled: search.nonLimitedOnly }"
                                        v-model="search.plcOwned"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                    </div>

                    <div class="fields-grid">
                        <checkbox-input class="field"
                                        :label="'Private Equity House Only'"
                                        v-bind:class="{ disabled: search.nonLimitedOnly }"
                                        :identifier="'plcHouse'"
                                        :attrs="{ disabled: search.nonLimitedOnly }"
                                        v-model="search.plcHouse"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                        <checkbox-input class="field"
                                        :label="'Has Acquired'"
                                        v-bind:class="{ disabled: search.nonLimitedOnly }"
                                        :identifier="'hasAcquired'"
                                        :attrs="{ disabled: search.nonLimitedOnly }"
                                        v-model="search.hasAcquired"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                        <checkbox-input class="field"
                                        :label="'Has Been Acquired'"
                                        v-bind:class="{ disabled: search.nonLimitedOnly }"
                                        :identifier="'beenAcquired'"
                                        :attrs="{ disabled: search.nonLimitedOnly }"
                                        v-model="search.beenAcquired"
                                        v-on:valueChanged="formChanged"></checkbox-input>
                    </div>
                </div>
            </section>

            <section class="form-section number-search">
                <h2>
                    Company Name &amp; Registered Number Search
                    <button aria-label="Minimise company search"
                            @click.prevent="toggleSection('numbers')">
                        <font-awesome-icon :icon="sectionIcon('numbers')" />
                    </button>
                    <button aria-label="Clear company search values"
                            @click.prevent="clearValuesFromSection('numbers')">
                        <font-awesome-icon icon="times-circle" />
                    </button>
                </h2>
                <div class="must-include-wrapper">
                    <span class="must-include-spacer"></span>
                    <checkbox-input class="must-include italics"
                                    :label="'Must include all Company Numbers'"
                                    :identifier="'mustIncludeCompanyNumbers'"
                                    v-model="search.mustIncludeCompanyNumbers"
                                    v-on:valueChanged="formChanged"></checkbox-input>
                </div>
                <div v-if="sectionsVisible.numbers">
                    <textarea-input class="field"
                                    :label="'Company number(s)'"
                                    :identifier="'companyNumbers'"
                                    v-model="includeCompanyNumbers"
                                    :display="'row'"
                                    :label-width="250"
                                    v-on:valueChanged="formChanged"
                                    :error="searchError.CompanyNumbers"></textarea-input>

                    <div class="field">
                        <company-id-uploader @arrayChanged="updateUploadedFiles"
                                             :uploadedFiles="search.files"
                                             @showError="showError"></company-id-uploader>
                    </div>
                    <!-- <multi-select-async-input
              class="field"
              :label="'Company name(s)'"
              :identifier="'companyNames'"
              :display="'row'"
              :label-width="250"
              :attrs="{ placeholder: 'Company name' }"
              v-model="search.includeCompanyNames"
              :multiple="true"
              v-on:valueChanged="formChanged"
              url="https://localhost:44345/company/QueryCompanyName"

              :option-track-by="'companyId'"
              :option-label="'companyName'"
            ></multi-select-async-input> -->
                    <multi-select-async-input class="field"
                                              :label="'Company name(s)'"
                                              :identifier="'companyNames'"
                                              :display="'row'"
                                              :label-width="250"
                                              :attrs="{ placeholder: 'Company name' }"
                                              v-model="search.includeCompanyNames"
                                              :multiple="true"
                                              v-on:valueChanged="formChanged"
                                              url="/company/QueryCompanyName"
                                              :option-track-by="'companyId'"
                                              :option-label="'companyName'"></multi-select-async-input>
                    <textarea-input class="field"
                                    :label="'Vendor Reference(s)'"
                                    :identifier="'venderReferences'"
                                    v-model="includeVendorReferences"
                                    :display="'row'"
                                    :label-width="250"
                                    v-on:valueChanged="formChanged"
                                    :error="searchError.VenderReferences"></textarea-input>

                    <!--<text-input class="field" :label="'Vendor Reference'" :identifier="'venderReference'" :display="'row'" :label-width="250"
                                      :attrs="{placeholder: 'Vendor Reference'}" v-model="search.venderReference" v-on:valueChanged="formChanged"></text-input>-->
                </div>
                <div class="fields-wrapper group">
                        <checkbox-input class="field"
                                        :label="'Exclude Do Not Send'"
                                        :identifier="'excludeDoNotSend'"
                                        v-model="search.excludeDoNotSend"
                                        v-on:valueChanged="excludeBlockedChanged"></checkbox-input>
                    </div>
            </section>

            <section class="form-section bqprofile">
                <h2>
                    BQ Profile
                    <button aria-label="Minimise company search"
                            @click.prevent="toggleSection('bqprofile')">
                        <font-awesome-icon :icon="sectionIcon('bqprofile')" />
                    </button>
                    <button aria-label="Clear company search values"
                            @click.prevent="clearValuesFromSection('bqprofile')">
                        <font-awesome-icon icon="times-circle" />
                    </button>
                </h2>

                <div v-if="sectionsVisible.bqprofile">
                    <div class="divider">
                        <table>
                            <tr>
                                <td><p>Keywords to include from BQ Profile</p></td>
                                <td class="optional-control">
                                    <checkbox-input class="field"
                                                    :label="'Include all'"
                                                    :identifier="'includeAll'"
                                                    v-model="search.bqProfileKeywordIncludeAll"
                                                    v-on:valueChanged="setBQProfileKeywordIncludeAll"></checkbox-input>
                                </td>
                                <td></td>
                            </tr>
                            <tr v-for="(item, index) in search.bqProfileIncludeKeywords" :key="item.id">
                                <td>
                                    <text-input class="field text-field"
                                                :identifier="'includeKeyword' + index"
                                                :attrs="{ placeholder: 'Keywords' }"
                                                v-model="item.keyword"
                                                v-on:valueChanged="formChanged"
                                                :error="
                          searchError['BQProfileIncludedKeywords[' + index + ']Keyword']
                        "></text-input>
                                </td>
                                <td class="optional-control">
                                    <checkbox-input class="field"
                                                    :label="'Must include'"
                                                    :identifier="'mustInclude' + index"
                                                    v-model="item.mustInclude"
                                                    v-on:valueChanged="formChanged"></checkbox-input>
                                </td>
                                <td>
                                    <button type="button"
                                            class="remove-button"
                                            @click.prevent="removeBQProfileIncludedKeyword(index)">   
                                        <font-awesome-icon icon="minus-circle" /> Remove
                                    </button>
                                </td>
                            </tr>
                        </table>
                        <button class="add-button"
                                type="button"
                                v-on:click="addBQProfileIncludedKeyword">                          
                            <font-awesome-icon icon="plus-circle" /> Add keyword
                        </button>
                        
                    </div>
                </div>
            </section>


            <div class="bottom-bar">
                <div class="display-results-form">
                    <company-count :search="search"></company-count>
                    <input-button class="search-btn"
                                  :btn-class="'btn-primary'"
                                  :disabled="saving || hasErrors || search.loadingResults">
                        Display results<font-awesome-icon icon="search" />
                    </input-button>
                    <font-awesome-icon icon="spinner"
                                       v-if="saving || search.recalculatingCount ||  search.loadingResults" />
                    <font-awesome-icon icon="spinner"
                                       v-if="saving || search.recalculatingCount ||  search.loadingResults" />
                    <h3 class="information" v-if="search.loadingResults == true"><font-awesome-icon style="	display:inline-block;!important" icon="spinner"></font-awesome-icon>Results are being prepared... </h3>
                </div>

                <div class="tools-btns">
                    <load-saved-search @contentRead="loadSavedSearch"
                                       class="load-search">
                        Load Search <font-awesome-icon icon="upload" />
                    </load-saved-search>
                    <save-search class="save-search" :search="search">
                        Save Search <font-awesome-icon icon="save" />
                    </save-search>
                    <div @click.prevent="clearAllValues">
                        <input-button :btn-class="'btn-grey'">
                            Clear All <font-awesome-icon icon="minus-circle" />
                        </input-button>
                    </div>
                </div>
            </div>
        </form>

        <info-box v-if="isInfoBoxVisible" @close="closeInfoBox">
          <!-- <h2 slot="header">{{ infoBoxHeader }}</h2> -->
          <!-- <div slot="body">{{ infoBoxBody }}</div> -->
        </info-box>
      </main-content>

      <aside>
        <div :class="{ fixBox: fixBox }">
          <p>
            <strong>Status<br /></strong>
            <span v-if="status.savingField">Saving search data</span>
            <span v-if="status.updatingCount">Updating count</span>
            <span v-if="!status.updatingCount && !status.savingField"
              >Waiting</span
            >
            <font-awesome-icon
              icon="spinner"
              v-show="saving || search.recalculatingCount"
            />
          </p>
        </div>
      </aside>
    </div>
  </div>
</template>

<script>

    /* eslint-disable */
    import Vue from 'vue'
    import SiteHeader from '../components/header/SiteHeader'
    import InputButton from '../components/reusable/InputButton'
    import Breadcrumb from '../components/reusable/Breadcrumb'
    import MainContent from '../components/reusable/MainContent'
    import TextInput from '../components/reusable/TextInput'
    import MultiSelectInput from '../components/reusable/MultiSelectInput'
    import MultiSelectAsyncInput from '../components/reusable/MultiSelectAsyncInput'
    import TextareaInput from '../components/reusable/TextareaInput'
    import CheckboxInput from '../components/reusable/CheckboxInput'
    import RadioInput from '../components/reusable/RadioInput'
    import SelectInput from '../components/reusable/SelectInput.vue'
    import CompanyIdUploader from '../components/reusable/CompanyIdUploader'
    import PrintIcon from '../components/other/PrintIcon'
    import LoadSavedSearch from '../components/other/LoadSavedSearch'
    import SaveSearch from '../components/other/SaveSearch'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import store from '../store'
    import { mapState, mapActions } from 'vuex'
    import { isSet, isArray, isJsonString, isIE } from '../helpers/helpers';
    import { resetState } from '../store/reset';
    import InfoBox from '../components/reusable/InfoBox'
    import CompanyCount from '../components/other/CompanyCount'

    export default {
        name: 'CompanySearch',
        data() {
            return {
                fixBox: false,
                isIE: false,
                highResultsCount: false,
                wildCardError: false,
                loading: false
            }
        },
        props: ['companySearchId'],
        created() {
            if (!this.dataLoaded) {
                this.search.companySearchId = this.companySearchId;
                if (isSet(this.search.companySearchId)) {
                    this.$store.dispatch('companysearchmodule/getCompanySearch').then(() => {
                        this.loadData();
                    });
                }
                else {
                    this.loadData();
                }
            }
            else {
                this.loadData();
            }

            if (typeof window != 'undefined') {
                window.addEventListener('scroll', this.handleScroll);
            }

            this.isIE = isIE();
        },

        components: {
            SiteHeader,
            InputButton,
            Breadcrumb,
            MainContent,
            TextInput,
            MultiSelectInput,
            MultiSelectAsyncInput,
            TextareaInput,
            CheckboxInput,
            RadioInput,
            SelectInput,
            PrintIcon,
            CompanyIdUploader,
            FontAwesomeIcon,
            LoadSavedSearch,
            SaveSearch,
            InfoBox,
            CompanyCount
        },
        computed: {
            ...mapState({
                countries: state => state.countrymodule.allCountries,
                regions: state => state.regionmodule.allRegions,
                postcodes: state => state.postcodemodule.allPostcodes,
                sectors: state => state.sectormodule.allSectors,
                subSectors: state => state.subsectormodule.allSubSectors,
                sicCodes: state => state.siccodemodule.allSicCodes,
                saving: state => state.companysearchmodule.saving,
                searchError: state => state.companysearchmodule.searchError,
                dataLoaded: state => state.companysearchmodule.dataLoaded,
                infoBoxHeader: state => state.companysearchmodule.infoBoxHeader,
                infoBoxBody: state => state.companysearchmodule.infoBoxBody,
                status: state => state.companysearchmodule.status,

            }),

            search: {
                get() {
                    return this.$store.state.companysearchmodule.search
                },
                set(value) {
                    this.$store.commit('companysearchmodule/updateSearch', value)
                }
            },
            searchCount: {
                get() {
                    return this.$store.state.companysearchmodule.searchCount
                },

            },
            sectionsVisible: {
                get() {
                    console.log(this.$store.state.companysearchmodule.sectionsVisible);
                    return this.$store.state.companysearchmodule.sectionsVisible
                },
                set(value) {
                    this.$store.commit('companysearchmodule/updateSectionsVisible', value)
                }
            },
            includeCompanyNumbers: {
                get() {
                    return this.search.includeCompanyNumbers.map(e => e.companyNumber).join(', ')
                },
                set(value) {
                    let companyNumbers = [];

                    let strReplaceNewlines = value.replace(/\n/g, ',').replace(/ /g, ',');

                    for (let companyNumber of strReplaceNewlines.split(',').map(e => e.trim())) {
                        if (isSet(companyNumber)) companyNumbers.push({ companyNumber: companyNumber });
                    }

                    this.search.includeCompanyNumbers = companyNumbers;
                }
            },
            includeVendorReferences: {
                get() {
                    return this.search.includeVendorReferences.map(e => e.vendorReference).join(', ')
                },
                set(value) {
                    let vendorReferences = [];

                    let strReplaceNewlines = value.replace(/\n/g, ',').replace(/ /g, ',');

                    for (let vendorReference of strReplaceNewlines.split(',').map(e => e.trim())) {
                        if (isSet(vendorReference)) vendorReferences.push({ vendorReference: vendorReference });
                    }

                    this.search.includeVendorReferences = vendorReferences;
                }
            },
            isInfoBoxVisible: {
                get() {
                    return this.$store.state.companysearchmodule.isInfoBoxVisible
                },
                set(value) {
                    this.$store.commit('companysearchmodule/updateIsInfoBoxVisible', value)
                }
            },
            hasErrors() {
                if (Object.keys(this.searchError).length > 0) return true;
                if (this.checkResultCount() == true) return true;

                else return false;
            },

            test() {
                if (typeof window != 'undefined' && window.scrollY > 200) {
                    return true;
                }
                else {
                    return false;
                }
            }
        },
        methods: {
            ...mapActions('fileuploadmodule', [
                'uploadFileOfCompanyIds'
            ]),
            ...mapActions('companysearchmodule', [
                'addIncludedKeyword',
                'removeIncludedKeyword',
                'addExcludedKeyword',
                'removeExcludedKeyword',
                'addSector',
                'removeSector',
                'addSicCode',
                'removeSicCode',
                'showResults',
                'requestCompanyResultCount',
                'requestCompanySave',
                'removeBQProfileIncludedKeyword',
                'addBQProfileIncludedKeyword'
            ]),
            displayResults() {
                if (this.formIsValid()) {

                    if (this.search.resultStatus == 2) {
                        this.$store.commit('companysearchmodule/updateInfoBox', { isVisible: true, header: 'Too many Results', body: 'Your search currently returns too many results, please refine your query further.' });
                        return;
                    }
                    if (!this.saving) {
                        this.loading = true;
                        Vue.set(store.state.companysearchresultmodule, 'resultsCount', 0);
                        this.showResults();
                    }
                }
            },
            loadData() {
                this.$store.dispatch('countrymodule/getCountries');
                this.$store.dispatch('regionmodule/getRegions');
                this.$store.dispatch('postcodemodule/getPostcodes');
                this.$store.dispatch('sectormodule/getSectors');
                this.$store.dispatch('subsectormodule/getSubSectors');
                this.$store.dispatch('siccodemodule/getSicCodes');
            },
            loadFile() {
                var formData = new FormData();
                var totalFiles = this.$refs.fileInput.files.length;

                for (var i = 0; i < totalFiles; i++) {
                    var file = this.$refs.fileInput.files[i];
                    formData.append('file', file);
                }

                // console.log(this.uploadFileOfCompanyIds(formData));
            },
            formChanged(event) {
                this.fixAllNumberFieldsForBlankString();
                if (this.formIsValid()) {
                    this.requestCompanySave();
                    this.requestCompanyResultCount();

                    this.$store.commit('companysearchresultmodule/updateResultsPage', 0);
                }
                // if(this.checkResultCount() == true){
                //   this.highResultsCount = true
                // }
                else {
                    this.highResultsCount = false
                }
            },
            fixAllNumberFieldsForBlankString() {
                if (this.search.minTurnover === "")
                    this.search.minTurnover = null;
                if (this.search.maxTurnover === "")
                    this.search.maxTurnover = null;
                if (this.search.minEBITDA === "")
                    this.search.minEBITDA = null;
                if (this.search.maxEBITDA === "")
                    this.search.maxEBITDA = null;
                if (this.search.minShareholdersFunds === "")
                    this.search.minShareholdersFunds = null;
                if (this.search.maxShareholdersFunds === "")
                    this.search.maxShareholdersFunds = null;
                if (this.search.minCash === "")
                    this.search.minCash = null;
                if (this.search.maxCash === "")
                    this.search.maxCash = null;
                if (this.search.minEmployees === "")
                    this.search.minEmployees = null;
                if (this.search.maxEmployees === "")
                    this.search.maxEmployees = null;

            },
            checkWildcard() {

                for (const includedKeywordsKey of this.search.includedKeywords) {
                    if (includedKeywordsKey.keyword.includes("*") && includedKeywordsKey.includes(" ")) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            },
            nonLimitedOnlyChanged() {

                if (this.search.nonLimitedOnly === true) {
                    this.clearValuesFromSection('ForNonLimitedOnly');
                    // this.clearValuesFromSection('financials');
                    // this.clearValuesFromSection('buyerTraits');
                    this.setSection('financials', false);
                } else {
                    this.setSection('financials', true);
                    this.formChanged()
                }


            },
            excludeBlockedChanged() {
                this.formChanged();
            },
            checkResultCount() {

                if (this.search.resultCount > 3000 || this.search.resultCount == 0) {
                    return true
                }

            },


            formIsValid() {
                let formIsValid = true;
                this.wildCardError = false;
                // console.log("validation");
                Vue.set(store.state.companysearchmodule, 'searchError', {});

                // Check if all sic code boxes are populated
                let indexOfBlankSic = this.search.sicCodes.findIndex(x => x.sicCodeId === '');
                if (indexOfBlankSic > -1) {
                    formIsValid = false;
                    Vue.set(store.state.companysearchmodule.searchError, `SicCodes[${indexOfBlankSic}]SicCodeId`, 'Please choose a SIC code');
                }

                // Check if all sector boxes are populated
                let indexOfBlankSector = this.search.sectors.findIndex(x => x.sectorId === '');
                if (indexOfBlankSector > -1) {
                    formIsValid = false;
                    Vue.set(store.state.companysearchmodule.searchError, `Sector[${indexOfBlankSector}]SectorId`, 'Please choose a Sector');
                }
                for (const includedKeywordsKey of this.search.includedKeywords) {
                    // console.log(includedKeywordsKey.keyword);
                    // if (includedKeywordsKey.keyword.includes("*")){
                    //   console.log("* true");
                    // }
                    // if (includedKeywordsKey.keyword.includes(" ")){
                    //   console.log("space true")
                    // }
                    if (includedKeywordsKey.keyword.trim().includes("*") && includedKeywordsKey.keyword.trim().includes(" ")) {
                        formIsValid = false;
                        this.wildCardError = true;
                    }
                }
                if (!formIsValid) this.$store.commit('companysearchmodule/updateInfoBox', { isVisible: true, header: 'Validation Error', body: 'Fix validation errors to continue' });

                return formIsValid;
            },
            updateUploadedFiles(val) {
                this.search.files = val;
                this.formChanged();
            },
            toggleSection(sectionName) {
                this.sectionsVisible[sectionName] = !this.sectionsVisible[sectionName];
            },
            setSection(sectionName, isOpened) {
                this.sectionsVisible[sectionName] = isOpened;
            },
            sectionIcon(sectionName) {
                if (this.sectionsVisible[sectionName]) return 'angle-down';
                else return 'angle-up';
            },
            clearAllValues() {
                resetState('CompanySearch');
                console.log("Search Reset");
            },
            clearValuesFromSection(sectionName) {
                console.log("SectionClear: " + sectionName);
                resetState('CompanySearch', sectionName);
            },
            loadSavedSearch(value) {
                // TO DO - Validate JSON to ensure it is a valid search object
                if (isJsonString(value)) {
                    let data = JSON.parse(value);
                    data.recalculatingCount = false;
                    this.$store.commit('companysearchmodule/updateSearch', data);
                }
            },
            loadSavedSearchError() {
                this.$store.commit('companysearchmodule/updateInfoBox', { isVisible: true, header: 'Load Search Failed', body: 'Failed to load search data, please ensure it is a .txt file' });
            },
            filterSubSectors: function (sectorId) {
                return this.subSectors.filter(function (el) {
                    return el.sectorId == sectorId;
                })
            },
            setSectorName(item) {
                let sectorId = parseInt(item.sectorId);
                item.subSectorId = 0;

                var sector = this.sectors.find(x => x.key === sectorId);
                item.sectorName = sector.value;
            },
            setSubSectorName(item) {
                if (item.subSectorId === '') {
                    subSectorId = 0
                    item.subSectorName = "All Sub Sectors";
                    return 0;
                }

                let subSectorId = parseInt(item.subSectorId);

                var subSector = this.subSectors.find(x => x.key === subSectorId);
                item.subSectorName = subSector.value;

                //item.subSectorName = this.subSectors[subSectorId].value;
            },
            closeInfoBox() {
                this.isInfoBoxVisible = false;
            },
            setKeywordIncludeAll() {
                if (this.search.includedKeywords.length > 0) {
                    let ticked = this.search.keywordIncludeAll;

                    for (let keyword of this.search.includedKeywords) {
                        keyword.mustInclude = ticked;
                    }

                    this.formChanged();
                }
            },
            setBQProfileKeywordIncludeAll() {
                if (this.search.bqProfileIncludeKeywords.length > 0) {
                    let ticked = this.search.bqProfileKeywordIncludeAll;

                    for (let keyword of this.search.bqProfileIncludeKeywords) {
                        keyword.mustInclude = ticked;
                    }

                    this.formChanged();
                }
            },
            setKeywordSearchAll() {
                if (this.search.includedKeywords.length > 0) {
                    let ticked = this.search.keywordSearchAll;

                    for (let keyword of this.search.includedKeywords) {
                        keyword.searchName = ticked;
                    }

                    this.formChanged();
                }
            },
            handleScroll(event) {
                if (!this.isIE && window.pageYOffset > 150) this.fixBox = true;
                else this.fixBox = false;
            },
            showError({ header, body }) {
                this.$store.commit('companysearchmodule/updateInfoBox', { isVisible: true, header: header, body: body });
            }
        }
    }
</script>

<style lang="scss" scoped>
	.must-include-wrapper {

		display:flex;

		.must-include {
			width: 33%;
			margin-bottom: 12px;
			padding-left: 10px;
		}

		.must-include-spacer {
			width: 66%;
		}

		@media only screen and (max-width: 800px) {
			.must-include {
				width: 100%;
				margin-bottom: 12px;
				padding-left: 10px;
			}

			.must-include-spacer {
				display:none;
			}
		}
	}


	.company-search {
		padding-bottom: 40px;
	}

	.container{
		display:flex;
	}

	aside{
		margin:30px 0 30px 0;
		min-width:250px;

		> div{
			position:relative;
			display: inline-block;
			padding: 0;
			width: 100%;
			background: #38b7ea;
			color: #fff;
			padding: 20px;
		}

		.fa-spinner{
			position: absolute;
			top: 22px;
			right: 20px;
		}

		.fixBox{
			position:fixed;
			top:30px;

			.fa-spinner{
				position: fixed;
				top: 50px;
			}
		}

		p{
			margin:0;
			max-width:200px;
		}


	}

	.main-content {
		margin: 30px;
		flex-grow:1;
	}

	@media only screen and (max-width: 1400px) {
		aside
		{
			display:none;
		}
	}

	.field {
		position:relative;
	}

	section {
		h2 {
			button: nth-of-type(1) {
				margin-left: 5px;
			}
			button {
				background: none;
				border: 0;
				padding: 0;
				margin: 0 2px;
				cursor:pointer;
			}
			svg {
				margin-left: 1px;
				margin-right: 1px;
				color: #cecece;
			}
			svg.fa-angle-down:hover {
				color: #000;
			}
			svg.fa-times-circle:hover {
				color: #d43131;
			}
		}
	}

	.industry-activities {
		h2 {
			margin-bottom: 10px;
		}
		.divider:nth-child(1) {
			padding-bottom:20px;
		}
		.divider:nth-child(n+2) {
			padding: 20px 0;
		}
		.divider:nth-child(even) {
			background: #fbfbfb;
		}
		table {
			width: 100%;
			td {
				vertical-align: initial;
			}
			.field {
				margin-bottom: 0;
			}
			.text-field {
				margin-bottom: 15px;
			}
			p {
				margin-top: 0;
				margin-bottom: 10px;
			}
		}
		.extra-controls {
			margin-top: 20px;
			display: flex;
			.field {
				margin-right: 20px;
				margin-bottom: 0;
				flex-grow: 0;
			}
			@media only screen and (max-width: 800px) {
				display: block;
				.field {
					margin-bottom: 20px;
				}
			}
		}
	}

	.financials {
		p:first-child {
			min-width: 170px;
		}
		p {
			margin-top: 8px;
			clear: both;
		}
		p.mil {
			margin-left: 10px;
			width:67px;
		}
		.fields-wrapper .field{
			margin-bottom: 35px;
		}
		.field:nth-child(5) {
			margin-top: 8px;
			min-width: 200px;
		}
		.extra-controls {
			margin-top: 20px;
			display: flex;
			margin-bottom: 50px;
			.field {
				margin-right: 20px;
				margin-bottom: 0;
				flex-grow: 0;
			}
		}
		@media only screen and (max-width: 800px) {
			.fields-wrapper {
				margin-bottom: 40px;
			}
			p.mil {
				margin-left: 0;
			}
			.extra-controls {
				display: block;
			}
		}
	}

	.company-search-section {
		.fields-wrapper {
			width: 100%;
		}
		.field {
			width: 48%;
			float: left;
		}
		.field:nth-of-type(1) {
			margin-right: 2%;
		}
		.field:nth-of-type(2) {
			margin-left: 2%;
		}
		@media only screen and (max-width: 800px) {
			.field {
				width: 100%;
				float: none;
				margin-left: 0 !important;
			}
		}
	}

	.financials,
	.industry-activities {
		@media only screen and (min-width: 800px) {
			.fields-wrapper {
				display: flex;
				justify-content: flex-start;
			}
			.field {
				margin-bottom: 20px;
				flex-grow: 1;
			}
			.field:nth-child(1) {
				margin-right: 40px;
			}
			.field:not(:nth-child(1)) {
				margin-left: 40px;
			}
		}
	}

	.display-results-form {
		display: flex;
		.search-btn {
			margin-left: 20px;
			svg {
				width: 15px;
				height: 15px;
			}
		}
		.search-btn:disabled{
			background:#f1f1f1;
			cursor:not-allowed;
		}

		.fa-spinner{
			display:none;
		}

		@media only screen and (max-width: 800px){
			display:block;

			.search-btn {
				margin: 20px 0 0 0;
			}
		}

		@media only screen and (max-width: 1400px){
			.fa-spinner{
				display:inline-block;
			}
		}


	}

	.buyer-traits {
		@media only screen and (min-width: 800px) {
			.fields-grid {
				display: flex;
				.field {
						   width:33.33%;
				       }
			}
		}
	}

	.number-search {
		.field:nth-of-type(1) {
			min-height: 100px;
		}
		.choose-file {
			input {
				display: block;
				margin-top: 10px;
				margin-bottom: 20px;
			}
			@media only screen and (min-width: 800px) {
				input {
					margin-bottom: 0;
				}
				div {
					display: flex;
				}
			}
		}
	}

	.top-bar {
		margin-bottom: 40px;
	}

	.bottom-bar,
	.top-bar {
		@media only screen and (min-width: 1401px) {
			display: flex;
			justify-content: space-between;
		}
		.tools-btns {
			display: flex;

			.save-search, .load-search, button {
				margin-left: 20px;
				@media only screen and (max-width: 1400px) {
					margin: 20px 20px 0 0;
				}
				svg {
					width: 15px;
					height: 15px;
				}
			}
			@media only screen and (max-width: 800px) {
				display:none;
			}
		}
	}

	.disabled, .disabled h2 {
		color: lightgrey !important;
	}

	.h2 {
		margin-top: 20px;
	}

	.field {
		margin-bottom: 20px;
	}

	.italics {
		font-style:italic;
	}

	.form-section {
		margin-bottom: 40px;
	}

	.add-button {
		background: none;
		border: 0;
		svg {
			color: #0ac70a;
			margin-right: 5px;
			width: 15px;
			height: 15px;
		}
	}

	.remove-button {
		background: none;
		border: 0;
		height: 20px;
		svg {
			margin-right: 5px;
			color: #d43131;
			width: 15px;
			height: 15px;
			vertical-align: -.125em !important;
		}
	}

	.fa-spinner{
		margin-left:20px;
	}

	.error {
		font-size:0.8em;
		color:#d43131;
	}

	@media only screen and (max-width: 1000px) {
		.optional-control {
			display: none;
		}
	}
</style>
